<template lang="pug">
b-input(
  ref="input"
  icon="cellphone"
  :placeholder="placeholder"
  :value="number"
  @input="update"
)
</template>

<script>
export default {
  name: 'phone-field',
  $_veeValidate: {
    value() {
      return this.number;
    },
  },
  created() {
    const params = Object.assign({}, { number: this.value });
    this.number = params.number;
  },
  data() {
    return {
      number: null,
    };
  },
  methods: {
    update(val) {
      const formatted = val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      this.number = formatted;
      this.$emit('input', formatted);
    },
  },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  watch: {
    value(val) {
      if (!val) this.number = null;
    },
  },
};
</script>

<style lang="css">
</style>
